<div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <a class="layout-topbar-logo" routerLink="/">
                <img src="/assets/logo/election-drive-logo.png" class="logo" alt="Kordika">
            </a>
        </div>

        @if(electionName) {
        <div class="flex items-center w-full">
            <a routerLink="/" class="flex items-center text-surface-500 hover:text-surface-900 dark:hover:text-surface-0 cursor-pointer mr-3 transition-colors" title="Back to Elections">
                <i class="pi pi-arrow-left mr-1"></i>
                <span class="hidden md:inline text-sm">Elections</span>
            </a>
            <span class="text-surface-400 mr-3 hidden md:inline">/</span>
            <div class="text-center flex-1">
                <b class="text-surface-900 dark:text-surface-0 text-xl font-medium">
                    {{electionName}}</b>
                @if(daysRemaining != null && daysRemaining >= 0 && daysRemaining != 1) {
                    <span class="text-surface-500 ml-2">({{daysRemaining}} days remaining)</span>
                } @else if (daysRemaining != null && daysRemaining == 1) {
                    <span class="text-surface-500 ml-2">({{daysRemaining}} day remaining)</span>
                }
            </div>
        </div>
        }


        <div class="layout-topbar-actions">


            <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    @if(isAdmin()) {
                      <button type="button" class="layout-topbar-action" (click)="settings.toggle($event)">
                        <i class="pi pi-cog"></i>
                        <span>Settings</span>
                      </button>
                    }

                    <button type="button" class="layout-topbar-action">
                        <i class="pi pi-envelope"></i>
                        <span>Notifications</span>
                    </button>                    
                    <button type="button" class="layout-topbar-action" (click)="op.toggle($event)">
                        <i class="pi pi-user"></i>
                        <span>Profile</span>
                    </button>
                </div>
            </div>
        </div>
</div>

<p-popover #op>
    <ul class="list-none p-0 m-0">
        <li>
            <span class="px-4 py-2 rounded-md 
                         transition-colors duration-150 flex items-center space-x-2"  
                         ><p-avatar icon="pi pi-user" class="mr-2" size="normal"  shape="circle" />
                         {{username}}</span>            
        </li>
        <p-divider></p-divider>
        <li class="flex justify-center items-center">
            <span class="px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md 
                         transition-colors duration-150 flex items-center space-x-2"  
                         (click)="logout()">Logout</span>
        </li>
    </ul>
</p-popover>

<p-popover #settings>
    <ul class="list-none p-0 m-0">
        <li>
            <span class="px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md 
                         transition-colors duration-150 flex items-center space-x-2"  
                         (click)="goSettings('account')">Account</span>
        </li>
        <li>
            <span class="px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md 
                         transition-colors duration-150 flex items-center space-x-2"  
                         (click)="goSettings('organization')">Organization</span>
        </li>
        <li>
            <span class="px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md 
                         transition-colors duration-150 flex items-center space-x-2"  
                         (click)="goSettings('user')">User</span>
        </li>        
    </ul>
</p-popover>